import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import logo from "@/assets/tabletalk-tv-logo-header.png";

const CAL_LINK = "https://cal.com/tabletalktv"; // TODO: Replace https://cal.com/tabletalktv with your Cal.com booking URL

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-xl border-b border-[var(--color-border)] shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#" className="flex items-center" aria-label="TableTalk TV - Long Island Diner TV Network">
            <img
              src={logo}
              alt="TableTalk TV - Long Island Diner TV Network"
              width={480}
              height={128}
              fetchPriority="high"
              className="h-10 md:h-12 w-auto object-contain"
            />

          </a>

          <div className="hidden md:flex items-center gap-3">
            {/* TODO: Replace https://cal.com/tabletalktv with your Cal.com booking URL */}
            <a
              href={CAL_LINK}
              className="btn-primary px-5 py-2.5 text-sm"
            >
              Book a Call
            </a>
            <a
              href="tel:+15163433353"
              className="btn-secondary px-5 py-2.5 text-sm"
            >
              <Phone className="w-4 h-4" />
              Call Now
            </a>
          </div>

          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden text-[var(--color-text)] p-2"
            aria-label="Toggle menu"
          >
            {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden bg-white border-t border-[var(--color-border)] overflow-hidden"
          >
            <div className="px-4 py-6 flex flex-col gap-3">
              {/* TODO: Replace https://cal.com/tabletalktv with your Cal.com booking URL */}
              <a
                href={CAL_LINK}
                className="btn-primary w-full px-5 py-3 text-sm"
                onClick={() => setMenuOpen(false)}
              >
                Book a Call
              </a>
              <a
                href="tel:+15163433353"
                className="btn-secondary w-full px-5 py-3 text-sm"
                onClick={() => setMenuOpen(false)}
              >
                <Phone className="w-4 h-4" />
                Call Now
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
